import { ApiSlugs, CurrencyDto, LanguageDto, TimezoneDto, UserDto, UserId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';

export class UserInternationalizationConnector extends ApiConnector<UserDto, UserDto, UserId> {
  constructor(apiCaller: ApiCaller, slug: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${slug}/${ApiSlugs.INTERNATIONALIZATION}`);
  }

  updateLanguage(language: LanguageDto): Observable<LanguageDto> {
    return this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/language`, language);
  }

  updateTimezone(timezone: TimezoneDto): Observable<TimezoneDto> {
    return this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/timezone`, timezone);
  }

  updateCurrency(currency: CurrencyDto): Observable<CurrencyDto> {
    return this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/currency`, currency);
  }
}
